import * as soundBoxConfig from './config.json';

export function initSoundBox() {
    const soundBoxElement = document.getElementById("soundBox")
    if (!soundBoxElement) return
    soundBoxElement.style.display = "initial";


    const data = soundBoxConfig
    const soundBox = data
    const genres = Object.keys(soundBox)
    const genre = genres[0]

    // Fill menu
    var h = ""
    h += "<div id='list-genres' class='btn-group btn-group-toggle' data-toggle='buttons'>"
    for (var i = 0; i < genres.length; i++) {
        if (genre == genres[i]) {
            h += `<label class='btn btn-light btn-sm active'>
                <input type='radio' name='genre-${genres[i]}' autocomplete='off' checked>${genres[i]}
            </label>`
        } else {
            h += `<label class='btn btn-light btn-sm'>
            <input type='radio' name='genre-${genres[i]}' autocomplete='off'> ${genres[i]}
            </label>`
        }
    }
    h += "</div>"

    /*document.getElementById("musicGenreButtons").innerHTML = h
    //event on bootstrap buttons
    $("#list-genres input").on("click", function () {
        genre = this.name.split("-")[1]
        soundBox.data2partition()
        var settings = soundBox[genre].instruments["Main Keyboard"]
        aeroval.hm_synth = soundBox.createSynth(settings)
    });

    $("#playButton").on('click', function () {
        //toggle aeroval.play state
        aeroval.play = !aeroval.play;
        if (aeroval.play) {
            soundBox.playData()
            document.getElementById("faPlay").innerHTML = "<i id='faPlay' class='fas fa-stop'></i>"
        } else {
            document.getElementById("faPlay").innerHTML = "<i id='faPlay' class='fas fa-play'></i>"
            //stop synths
            var synth_names = Object.keys(aeroval.synths)
            for (var i = 0; i < synth_names.length; i++) {
                soundBox.stopSynth(synth_names[i])
            }
        }
    })*/

}

/*
function makeChordArray(root, triad) {
    //get index of root
    for (let i = 0; i < MIDI_NUM_NAMES.length; i++) {
        if (root == MIDI_NUM_NAMES[i]) {
            var iroot = i
            break
        }
    }
    var chordArray = []
    for (let i = 0; i < triad.length; i++) {
        chordArray.push(MIDI_NUM_NAMES[iroot + triad[i]])
    }
    return chordArray;
}

function movingAvg(array, count, qualifier) {

    // calculate average for subarray
    var avg = function (array, qualifier) {
        var sum = 0,
            count = 0,
            val;
        for (var i in array) {
            val = array[i];
            if (!qualifier || qualifier(val)) {
                sum += val;
                count++;
            }
        }
        return sum / count;
    };
    var result = [],
        val;
    // pad beginning of result with null values
    for (var i = 0; i < count - 1; i++)
        result.push(array[i]);
    // calculate average for each subarray and add to result
    for (var i = 0, len = array.length - count; i <= len; i++) {

        val = avg(array.slice(i, i + count), qualifier);
        if (isNaN(val))
            result.push(null);
        else
            result.push(val);
    }
    return result;
}

function closestIndex(num, arr) {
    let curr = arr[0],
        diff = Math.abs(num - curr);
    let index = 0;
    for (let val = 0; val < arr.length; val++) {
        let newdiff = Math.abs(num - arr[val]);
        if (newdiff < diff) {
            diff = newdiff;
            curr = arr[val];
            index = val;
        };
    };
    return index;
};

function getValidNotes() {
    //make a dictionnary from all notes with notes in requested keys
    valid_notes = []

    //get notes from requested keys
    var keys = window.soundBox[window.genre].keys
    var req_notes = []
    for (var i = 0; i < keys.length; i++) {
        req_notes = req_notes.concat(DIC_KEYS[keys[i]])
    }

    var valid_freq = []
    for (var i = 0; i < ALL_NOTES.length; i++) {
        if (req_notes.includes(ALL_NOTES[i].note)) {
            valid_freq.push(ALL_NOTES[i].frequency)
            valid_notes.push({
                note: ALL_NOTES[i].note,
                frequency: ALL_NOTES[i].frequency
            })
        }
    }
    window.fMin = getMin(valid_freq)
    window.fMax = getMax(valid_freq)
}

function getClosestNote(freq) {
    //dictionnay of key and frequencies
    if (freq == null) {
        return {
            name: null,
            frequency: null
        }
    } else {
        var keys = window.soundBox[window.genre].keys
        var imins = [];
        var mins = []

        //get array of valid frequencies
        var valid_freq = []
        for (var i = 0; i < valid_notes.length; i++) {
            valid_freq.push(valid_notes[i].frequency)
        }
        var imin = closestIndex(freq, valid_freq)
        return {
            name: valid_notes[imin].note,
            frequency: valid_notes[imin].frequency
        }
    }
}

function val2freq(val) {
    if (val == null) {
        return null
    } else {
        var newMin = window.fMin
        var newMax = window.fMax
        if (window.statistic.scale != null) {
            var oldMin = window.statistic.scale[0]
            var oldMax = window.statistic.scale[window.statistic.scale.length - 1]
        } else {
            var oldMin = 1
            var oldMax = 10
        }
        var oldRange = (oldMax - oldMin)
        var newRange = (newMax - newMin)

        var freq = (((val - oldMin) * newRange) / oldRange) + newMin
    }
    return eval(freq.toFixed(2))
}

function freq2val(freq) {
    if (freq == null) {
        return null
    } else {
        var oldMin = window.fMin
        var oldMax = window.fMax
        if (window.statistic.scale != null) {
            var newMin = window.statistic.scale[0]
            var newMax = window.statistic.scale[window.statistic.scale.length - 1]
        } else {
            var newMin = 1
            var newMax = 10
        }
        var oldRange = (oldMax - oldMin)
        var newRange = (newMax - newMin)

        var val = (((freq - oldMin) * newRange) / oldRange) + newMin
        return eval(val.toFixed(2))
    }
}

function completeLoop(array) {
    if (array.length % window.soundBox[window.genre].instruments['Drums'].period != 0) {
        var completeWith = window.soundBox[window.genre].instruments['Drums'].period - (window.grid.length % window.soundBox[window.genre].instruments['Drums'].period)
        var lastval = array[array.length - 1]
        for (var i = 0; i < completeWith; i++) {
            array.push(lastval)
        }
    }
    return array
}

function getDuration(arr) {
    var l = []
    for (var i = 0; i < arr.length; i++) {
        l.push(1)
        for (var j = i; j < arr.length; j++) {
            if (arr[j + 1] == arr[j]) {
                l[i]++
            } else {
                //skip following number
                var skip = l[i] - 1
                for (var k = 0; k < skip; k++) {
                    l.push(0)
                }
                i += skip
                break
            }
        }
    }
    return l
}

function data2partition() {

    getValidNotes()

    var keys = window.soundBox[window.genre].keys
    var instruments = Object.keys(window.soundBox[window.genre].instruments)

    var series = []
    window.notes = {}

    //- - - - - data value - - - - -
    var name = 'data value'
    if (window.tab == 'heatmap') {
        var data = window.grid
    } else if (window.tab == 'timeseries') {
        var data = window.ts_data
    }
    var data_v = []; var data_f = []
    for (var i = 0; i < data.length; i++) {
        data_v.push(eval(data[i].value))
        data_f.push(val2freq(eval(data[i].value)))
    }
    data_v = completeLoop(data_v)
    data_f = completeLoop(data_f)

    //creates time axis
    var time = [];
    var js_time = []
    for (var i = 0; i < data_v.length; i++) {
        time.push(60 * i / window.soundBox[window.genre].tempo)
        js_time.push(time[i] * 1000)
    }
    window.js_time = js_time
    window.time = time

    //plot on time axis
    var data = []
    for (var i = 0; i < data_v.length; i++) {
        data.push([js_time[i], data_v[i]])
    }

    series.push({
        name: name,
        id: name,
        color: '#c0c0c0',
        dashStyle: 'dash',
        data: data,
        yAxis: 0,
        marker: {
            enabled: false
        },
        showInLegend: false,
    })

    //- - - - - perfect score - - - - -
    var name = 'Perfect Score'
    if (instruments.includes(name)) {
        if (window.soundBox[window.genre].instruments)
            var perfect_scores = {
                'NMB': 0,
                'MNMB': 0,
                'R': 1,
                'R Spearman': 1,
                'FGE': 0,
                'NRMSE': 0,
                'Mean-Mod': null,
                'Mean-Obs': null
            }
        var perfect_v = []; var perfect_f = []; var perfect_n = []; var perfect_d = []
        for (var i = 0; i < data_v.length; i++) {
            perfect_v.push(perfect_scores[window.statistic.name])
            perfect_f.push(val2freq(perfect_scores[window.statistic.name]))
            perfect_n.push(getClosestNote(perfect_f[i]))
            perfect_d.push(1)
        }

        //visibility
        if (Object.keys(window.seriesVisibility).includes(name)) {
            var visible = window.seriesVisibility[name]
        } else {
            //default
            var visible = window.soundBox[window.genre].instruments[name].enabled
        }

        window.notes[name] = {
            value: perfect_v,
            note: perfect_n,
            frequency: perfect_f,
            duration: perfect_d,
            time: time
        }

        //plot on time axis
        var data = []
        for (var i = 0; i < perfect_v.length; i++) {
            data.push([js_time[i], perfect_v[i]])
        }

        series.push({
            name: name,
            id: name,
            color: '#4f4f4f',
            dashStyle: 'dot',
            data: data,
            yAxis: 0,
            visible: visible,
            marker: {
                enabled: false
            },
            lineWidth: 4,
            showInLegend: true,
        })
    }


    //- - - - - main keyboard - - - - -
    var name = 'Main Keyboard'
    if (instruments.includes(name)) {
        var mainkey_v = []; var mainkey_f = []; var mainkey_n = []
        //first, moving average
        if (window.soundBox[window.genre].movingAvg > 0) {
            data_v = movingAvg(data_v, window.soundBox[window.genre].movingAvg)
        }

        //then, merge if following notes are close enough
        for (var i = 0; i < data_v.length; i++) {
            if (i > 0) {
                if (Math.abs(data_f[i] - val2freq(mainkey_v[i - 1])) <= window.soundBox[window.genre].mergeAbsThr) {
                    mainkey_v.push(mainkey_v[i - 1])
                } else {
                    mainkey_v.push(data_v[i])
                }
            } else {
                mainkey_v.push(data_v[i])
            }
            mainkey_f.push(val2freq(mainkey_v[i]))
            mainkey_n.push(getClosestNote(mainkey_f[i]))
        }

        //replace values by values corresponding to played notes
        for (var i = 0; i < mainkey_v.length; i++) {
            mainkey_f[i] = mainkey_n[i].frequency
            mainkey_v[i] = freq2val(mainkey_f[i])
            //console.info(mainkey_v[i], mainkey_f[i])
        }

        //visibility
        if (Object.keys(window.seriesVisibility).includes(name)) {
            var visible = window.seriesVisibility[name]
        } else {
            //default
            var visible = window.soundBox[window.genre].instruments[name].enabled
        }

        //compute length array based on how many notes are the same
        l = getDuration(mainkey_f)

        window.notes[name] = {
            value: mainkey_v,
            note: mainkey_n,
            frequency: mainkey_f,
            duration: l,
            time: time
        }

        //plot on time axis
        var data = []
        for (var i = 0; i < mainkey_v.length; i++) {
            data.push([js_time[i], mainkey_v[i]])
        }

        series.push({
            name: name,
            id: name,
            color: '#4f4f4f',
            data: data,
            yAxis: 0,
            visible: visible,
            marker: {
                enabled: false
            }
        })

        var name = 'Attack Main Keyboard'
        var mainattack_v = []; var mainattack_f = []; var mainattack_n = [];
        for (var i = 0; i < mainkey_v.length; i++) {
            if (window.notes['Main Keyboard'].duration[i] > 0) {
                mainattack_v.push(mainkey_v[i])
            } else {
                mainattack_v.push(null)
            }
        }

        //plot on time axis
        var data = []
        for (var i = 0; i < mainattack_v.length; i++) {
            data.push([js_time[i], mainattack_v[i]])
        }

        series.push({
            name: name,
            id: name,
            color: '#4f4f4f',
            data: data,
            yAxis: 0,
            marker: {
                enabled: true
            },
            showInLegend: false,
            linkedTo: ':previous',
        })
    }

    //overwrite perfect score duration
    window.notes['Perfect Score'].duration = l


    //- - - - - chords - - - - - - -
    var name = 'Chords'
    if (instruments.includes(name)) {
        //the chords get the note of the mainkeyboard played and plays at period
        var chords_n = []; var chords_v = []; var chords_f = []; var chords_d = []
        for (var i = 0; i < data_v.length; i++) {
            if (i % window.soundBox[window.genre].instruments[name].period == 0) {
                if (data_v[i] != null) {
                    var root = window.notes["Main Keyboard"].note[i].name
                    var triad = window.soundBox[window.genre].instruments[name].triad
                    var chords = makeChordArray(root, triad)
                    chords_n.push(chords)
                    var cv = []; var cf = []
                    for (let j = 0; j < chords.length; j++) {
                        var f = Tone.Frequency(chords[j]).toFrequency()
                        cf.push(f)
                        cv.push(val2freq(f))
                    }
                    chords_v.push(cv)
                    chords_f.push(cf)
                } else {
                    chords_n.push(chords[i - 1])
                }
                chords_d.push(window.soundBox[window.genre].instruments[name].length)
            } else {
                arr_null = []
                for (let j = 0; j < window.soundBox[window.genre].instruments[name].triad.length; j++) {
                    arr_null.push(null)
                }
                chords_n.push(arr_null)
                chords_v.push(arr_null)
                chords_f.push(arr_null)
                chords_d.push(null)
            }
        }

        //visibility
        if (Object.keys(window.seriesVisibility).includes(name)) {
            var visible = window.seriesVisibility[name]
        } else {
            //default
            var visible = window.soundBox[window.genre].instruments[name].enabled
        }

        window.notes[name] = {
            note: chords_n,
            time: time,
            value: chords_v,
            frequency: chords_f,
            duration: chords_d
        }
        //plot on time axis each chord
        for (let j = 0; j < window.soundBox[window.genre].instruments[name].triad.length; j++) {
            var data = []
            for (var i = 0; i < chords_f.length; i++) {
                data.push([js_time[i], chords_f[i][j]])
            }
            if (j == 0) {
                var nm = 'Chords'
            } else if (j > 0) {
                var nm = 'Chords-' + j
                var linkedTo = ':previous'
                var showInLegend = false
            }
            series.push({
                name: nm,
                id: nm,
                color: 'gray',
                data: data,
                yAxis: 1,
                visible: visible,
                linkedTo: linkedTo,
                showInLegend: showInLegend,
                lineWidth: 0,
                zIndex: 0,
                marker: {
                    symbol: 'text:\uf00d'
                },
                icon: '\uf00d'
            })
        }
    }


    //- - - - - bass - - - - -
    var name = 'Bass'
    if (instruments.includes(name)) {
        var bass_v = []; var bass_f = []; var bass_d = []
        var d = window.soundBox[window.genre].instruments[name].length
        for (var i = 0; i < data_v.length; i++) {
            if (i % window.soundBox[window.genre].instruments[name].period == 0) {
                for (var j = 0; j < window.soundBox[window.genre].instruments[name].length; j++) {
                    if (i + j < data_v.length) {
                        if (data_v[i] != null) {
                            bass_v.push(data_v[i] * window.soundBox[window.genre].instruments[name].ratioMain)
                            bass_f.push(val2freq(data_v[i]) * window.soundBox[window.genre].instruments[name].ratioMain)
                        } else {
                            bass_v.push(bass_v[i - 1])
                            bass_f.push(bass_f[i - 1])
                        }
                    }
                    if (j == 0) {
                        bass_d.push(d)
                    } else {
                        bass_d.push(null)
                    }
                }
                i += j - 1
            } else {
                bass_v.push(null)
                bass_f.push(null)
                bass_d.push(null)
            }
        }
        //visibility
        if (Object.keys(window.seriesVisibility).includes(name)) {
            var visible = window.seriesVisibility[name]
        } else {
            //default
            var visible = window.soundBox[window.genre].instruments[name].enabled
        }
        window.notes[name] = {
            value: bass_v,
            frequency: bass_f,
            duration: bass_d,
            time: time
        }
        //plot on time axis
        var data = []
        for (var i = 0; i < bass_f.length; i++) {
            data.push([js_time[i], bass_f[i]])
        }
        series.push({
            type: 'area',
            name: name,
            id: name,
            color: '#e9e9e9',
            data: data,
            yAxis: 2,
            visible: visible,
            marker: {
                enabled: false
            }
        })
    }


    //- - - - - drums - - - - -
    var name = 'Drums'
    if (instruments.includes(name)) {
        var drums_v = []; var drums_f = []; var drums_d = [];
        for (var i = 0; i < data_v.length; i++) {
            if (i % window.soundBox[window.genre].instruments[name].period == 0) {
                if (data_v[i] != null) {
                    drums_v.push(data_v[i] * window.soundBox[window.genre].instruments[name].ratioMain)
                    drums_f.push(val2freq(data_v[i]) * window.soundBox[window.genre].instruments[name].ratioMain)
                } else {
                    drums_v.push(drums_v[i - 1])
                    drums_f.push(drums_f[i - 1])
                }
                drums_d.push(window.soundBox[window.genre].instruments[name].length)
            } else {
                //drums_v.push(null)
                drums_f.push(null)
                drums_d.push(null)
                drums_v.push(null)
            }
        }

        //visibility
        if (Object.keys(window.seriesVisibility).includes(name)) {
            var visible = window.seriesVisibility[name]
        } else {
            //default
            var visible = true
        }

        window.notes[name] = {
            frequency: drums_f,
            duration: drums_d,
            time: time
        }
        //plot on time axis
        var data = []
        for (var i = 0; i < drums_f.length; i++) {
            data.push([js_time[i], drums_f[i]])
        }
        series.push({
            name: name,
            id: name,
            color: 'black',
            data: data,
            yAxis: 2,
            visible: visible
        })
    }

    if (window.statistic.scale != null) {
        var ymin = window.statistic.scale[0]
        var ymax = window.statistic.scale[window.statistic.scale.length - 1]
    }

    //- - - - - valid notes - - - - -
    //frequency boundaries are defined by valid_notes
    var valid_freq = [];
    for (var i = 0; i < valid_notes.length; i++) {
        var data = []
        for (var j = 0; j < js_time.length; j++) {
            data.push([js_time[j], valid_notes[i].frequency])
        }
        series.push({
            name: valid_notes[i].note,
            id: valid_notes[i].note,
            color: '#e8e8e8',
            dashStyle: 'dot',
            data: data,
            yAxis: 1,
            marker: {
                enabled: false
            },
            showInLegend: false,
            zIndex: -1
        })
    }

    var chart = Highcharts.chart('soundTS', {
        title: {
            text: ''
        },
        subtitle: {
            text: 'DataPartition'
        },
        chart: {
            height: 300,
            animation: false
        },
        credits: {
            enabled: false
        },
        xAxis: {
            type: 'datetime',
            data: js_time,
            labels: {
                formatter: function () {
                    return Highcharts.dateFormat("%M:%S.%L", this.value);
                }
            }
        },
        yAxis: [{
            title: {
                text: window.statistic.name
            },
            min: ymin,
            max: ymax,
            startOnTick: false,
            endOnTick: false,
            gridLineWidth: 0
        }, {
            title: {
                text: 'frequency'
            },
            min: window.fMin,
            max: window.fMax,
            opposite: true,
            startOnTick: false,
            endOnTick: false,
            gridLineWidth: 0
        }, {
            title: {
                text: 'bass frequency'
            },
            min: 0,
            max: 1.5 * window.fMax,
            opposite: true,
            startOnTick: false,
            endOnTick: false,
            gridLineWidth: 0,
            visible: false
        }],
        series: series,
        plotOptions: {
            series: {
                showInLegend: true,
                events: {
                    legendItemClick: function (event) {
                        clickOnLegendItem(this)
                    }
                }
            }
        }
    }, function (chart) { //on complete
        //add statistics from the map
        chart.loopText = chart.renderer.text('Loop: ' + '0', chart.plotLeft + 20, 60).css({
            color: '#404040',
            fontSize: '12px',
            fontWeight: 'bold'
        }).attr({
            zIndex: 99
        }).add();
        chart.noteText = chart.renderer.text('', chart.plotLeft + 20, 80).css({
            color: '#404040',
            fontSize: '12px',
            fontWeight: 'bold'
        }).attr({
            zIndex: 99
        }).add();
    })
    window.hmts = chart

    //creates parts ready to play
    window.sequences = {}
    var instrs = Object.keys(window.soundBox[window.genre].instruments)
    for (var j = 0; j < instrs.length; j++) {
        var name = instrs[j]
        var notes = []
        for (var i = 0; i < window.notes[name].frequency.length; i++) {
            if (window.notes[name].duration[i] == null) {
                var d = null
            } else {
                var d = window.notes[name].duration[i] * window.soundBox[window.genre].instruments[name].length
            }
            notes.push({
                time: window.notes[name].time[i],
                //frequency: [window.notes[name].frequency[i]],
                frequency: window.notes[name].frequency[i],
                duration: d
            })
        }
        window.sequences[name] = notes
    }
}

function createSynth(settings) {
    var synth = new Tone[settings.type]({
        volume: settings.volume,
        oscillator: settings.oscillator,
        envelope: settings.envelope,
        baseUrL: settings.baseUrL,
        urls: settings.url
    }).toDestination();
    //add effects
    if (Object.keys(settings).includes('effects')) {
        var effects = Object.keys(settings.effects)
        for (var i = 0; i < effects.length; i++) {
            var effect = new Tone[effects[i]]().toDestination()
            synth.connect(effect)
        }
    }
    return synth
}

function playTS(inote, iloop) {
    //at each iteation: update time series
    window.hmts.axes[0].update({
        plotBands: {
            color: '#F5F5F5',
            from: window.js_time[inote] - 50, // 50ms on the left
            to: window.js_time[inote] + 50 // 50ms on the right
        }
    })
    //update noteText
    window.hmts.noteText.attr({
        text: 'Note: ' + window.notes['Main Keyboard'].note[inote].name
    })
    //update iloop
    var txt = 'Loop: ' + String(iloop)
    window.hmts.loopText.attr({
        text: txt
    })
}

function stopTS() {
    //update hmts chart
    window.hmts.axes[0].update({
        plotBands: null
    })
    var txt = 'Loop: 0'
    //update loopText
    window.hmts.loopText.attr({
        text: txt
    })
    //update noteText
    window.hmts.noteText.attr({
        text: ''
    })
}

function playData() {

    //set bpm value
    //Tone.Transport.bpm.value = window.soundBox[window.genre].tempo
    //Tone.Transport.PPQ = 1
    //Tone.Transport.loop = true
    //Tone.Transport.loopStart = window.time[0]
    //Tone.Transport.loopEnd = window.time[window.time.length - 1]


    //creates synthetizers
    synths = {}
    var instrs = Object.keys(window.soundBox[window.genre].instruments)
    for (var i = 0; i < instrs.length; i++) {
        var settings = window.soundBox[window.genre].instruments[instrs[i]]
        synths[instrs[i]] = createSynth(settings)
    }

    parts = {}

    var meter = new Tone.Meter();

    //play synths
    var synth_names = Object.keys(synths)
    for (var i = 0; i < synth_names.length; i++) {
        //playSequence(synth_names[i])
    }

    var inote = 0;
    var iloop = 1;

    function delayLoop(i) {
        var now = Tone.now()

        //update TS
        playTS(inote, iloop)

        //loop tracker
        if (inote % (window.notes['Main Keyboard'].note.length - 1) == 0) {
            if (inote > 0) {
                window.iloop++
                if (window.iloop == window.soundBox[window.genre].nloop) {
                    window.play = false
                }
            }
        }

        //if click on Play button
        if (window.play == false) {
            i = -1
            document.getElementById('faPlay').innerHTML = '<i id="faPlay" class="fas fa-play"></i>'
            stopTS()
            //play zeros notes qt 0.5 seconds
            var timetostop = 0.5
            for (var j = 0; j < instrs.length; j++) {
                synths[instrs[j]].triggerRelease(now + timetostop)
            }
        }

        //play synths
        var synth_names = Object.keys(synths)
        for (var j = 0; j < synth_names.length; j++) {
            var name = synth_names[j]
            if (window.hmts.get(name).visible) {
                if (inote % window.soundBox[window.genre].instruments[name].period == 0) {
                    var f = window.notes[name].frequency[inote]
                    var l = (60 / window.soundBox[window.genre].tempo) * window.notes[name].duration[inote]
                    var v = window.soundBox[window.genre].instruments[name].attackVelocity
                    if (l > 0) {
                        synths[name].triggerAttackRelease(f, l, now, v)
                    }
                }
            }
        }

        inote++
        if (inote == window.time.length) {
            inote = 0
            iloop++
        }

        if (--i > -1) {
            setTimeout(function () {
                delayLoop(i);
            }, (60 * 1000 / window.soundBox[window.genre].tempo));
        }
    }
    delayLoop(window.notes['Main Keyboard'].note.length * window.soundBox[window.genre].nloop)

}

function playSequence(name) {
    if (window.hmts.get(name).visible) {
        var sequence = window.sequences[name]
        console.info('play', name)
        var velocity = window.soundBox[window.genre].instruments[name].attackVelocity
        var iloop = 1
        var part = new Tone.Part(function (time, note) {
            var inote = Tone.Transport.ticks - 1
            //play the note
            //var f = window.sequences[name][inote].frequency
            //var d = window.sequences[name][inote].duration
            //var t = window.sequences[name][inote].time
            var f = note.frequency
            var d = note.duration

            synths[name].triggerAttackRelease(f, d, time);
            //update the chart
            playTS(inote, iloop)
            if (inote >= this.length) {
                iloop++
            }
        }, sequence);
        part.start(0);
    } else {
        console.info('does not play', name)
        var sequence = null
    }
}

function stopSynth(name) {
    synths[name].triggerRelease(0, 0, 0)
}

function playSound(value) {
    var instr = 'Main Keyboard'
    var settings = window.soundBox[window.genre].instruments[instr]
    if (typeof (window.hm_synth) == 'undefined') {
        window.hm_synth = createSynth(settings)
    }

    var note = getClosestNote(val2freq(value)).frequency
    var push = Tone.now()
    var v = window.soundBox[window.genre].instruments[instr].attackVelocity
    var l = window.soundBox[window.genre].instruments[instr].length * 15 / window.soundBox[window.genre].tempo
    window.hm_synth.triggerAttackRelease(note, l, push, v)
}

const DIC_KEYS = {
    'Guitar': ['E3', 'A4', 'D4', 'G4', 'B5', 'E6'],
    'A3': ['A3', 'B3', 'C#3', 'D3', 'E3', 'F#3', 'G#3'],
    '2': ['C3', 'F3', 'G3'],
    '3': ['C3', 'C#3', 'D3', 'D#3', 'E3', 'F3', 'F#3', 'G3', 'G#3', 'A3', 'A#3', 'B3'],
    '4': ['C4', 'C#4', 'D4', 'D#4', 'E4', 'F4', 'F#4', 'G4', 'G#4', 'A4', 'A#4', 'B4'],
    '5': ['C5', 'C#5', 'D5', 'D#5', 'E5', 'F5', 'F#5', 'G5', 'G#5', 'A5', 'A#5', 'B5']
}

const ALL_NOTES = [{
    "note": "A#0",
    "frequency": 29.14
},
{
    "note": "A#1",
    "frequency": 58.27
},
{
    "note": "A#2",
    "frequency": 116.54
},
{
    "note": "A#3",
    "frequency": 233.08
},
{
    "note": "A#4",
    "frequency": 466.16
},
{
    "note": "A#5",
    "frequency": 932.33
},
{
    "note": "A#6",
    "frequency": 1864.66
},
{
    "note": "A#7",
    "frequency": 3729.31
},
{
    "note": "A#8",
    "frequency": 7458.62
},
{
    "note": "A0",
    "frequency": 27.5
},
{
    "note": "A1",
    "frequency": 55
},
{
    "note": "A2",
    "frequency": 110
},
{
    "note": "A3",
    "frequency": 220
},
{
    "note": "A4",
    "frequency": 440
},
{
    "note": "A5",
    "frequency": 880
},
{
    "note": "A6",
    "frequency": 1760
},
{
    "note": "A7",
    "frequency": 3520
},
{
    "note": "A8",
    "frequency": 7040
},
{
    "note": "B0",
    "frequency": 30.87
},
{
    "note": "B1",
    "frequency": 61.74
},
{
    "note": "B2",
    "frequency": 123.47
},
{
    "note": "B3",
    "frequency": 246.94
},
{
    "note": "B4",
    "frequency": 493.88
},
{
    "note": "B5",
    "frequency": 987.77
},
{
    "note": "B6",
    "frequency": 1975.53
},
{
    "note": "B7",
    "frequency": 3951.07
},
{
    "note": "B8",
    "frequency": 7902.13
},
{
    "note": "C#0",
    "frequency": 17.32
},
{
    "note": "C#1",
    "frequency": 34.65
},
{
    "note": "C#2",
    "frequency": 69.3
},
{
    "note": "C#3",
    "frequency": 138.59
},
{
    "note": "C#4",
    "frequency": 277.18
},
{
    "note": "C#5",
    "frequency": 554.37
},
{
    "note": "C#6",
    "frequency": 1108.73
},
{
    "note": "C#7",
    "frequency": 2217.46
},
{
    "note": "C#8",
    "frequency": 4434.92
},
{
    "note": "C0",
    "frequency": 16.35
},
{
    "note": "C1",
    "frequency": 32.7
},
{
    "note": "C2",
    "frequency": 65.41
},
{
    "note": "C3",
    "frequency": 130.81
},
{
    "note": "C4",
    "frequency": 261.63
},
{
    "note": "C5",
    "frequency": 523.25
},
{
    "note": "C6",
    "frequency": 1046.5
},
{
    "note": "C7",
    "frequency": 2093
},
{
    "note": "C8",
    "frequency": 4186.01
},
{
    "note": "D#0",
    "frequency": 19.45
},
{
    "note": "D#1",
    "frequency": 38.89
},
{
    "note": "D#2",
    "frequency": 77.78
},
{
    "note": "D#3",
    "frequency": 155.56
},
{
    "note": "D#4",
    "frequency": 311.13
},
{
    "note": "D#5",
    "frequency": 622.25
},
{
    "note": "D#6",
    "frequency": 1244.51
},
{
    "note": "D#7",
    "frequency": 2489.02
},
{
    "note": "D#8",
    "frequency": 4978.03
},
{
    "note": "D0",
    "frequency": 18.35
},
{
    "note": "D1",
    "frequency": 36.71
},
{
    "note": "D2",
    "frequency": 73.42
},
{
    "note": "D3",
    "frequency": 146.83
},
{
    "note": "D4",
    "frequency": 293.66
},
{
    "note": "D5",
    "frequency": 587.33
},
{
    "note": "D6",
    "frequency": 1174.66
},
{
    "note": "D7",
    "frequency": 2349.32
},
{
    "note": "D8",
    "frequency": 4698.63
},
{
    "note": "E0",
    "frequency": 20.6
},
{
    "note": "E1",
    "frequency": 41.2
},
{
    "note": "E2",
    "frequency": 82.41
},
{
    "note": "E3",
    "frequency": 164.81
},
{
    "note": "E4",
    "frequency": 329.63
},
{
    "note": "E5",
    "frequency": 659.25
},
{
    "note": "E6",
    "frequency": 1318.51
},
{
    "note": "E7",
    "frequency": 2637.02
},
{
    "note": "E8",
    "frequency": 5274.04
},
{
    "note": "F#0",
    "frequency": 23.12
},
{
    "note": "F#1",
    "frequency": 46.25
},
{
    "note": "F#2",
    "frequency": 92.5
},
{
    "note": "F#3",
    "frequency": 185
},
{
    "note": "F#4",
    "frequency": 369.99
},
{
    "note": "F#5",
    "frequency": 739.99
},
{
    "note": "F#6",
    "frequency": 1479.98
},
{
    "note": "F#7",
    "frequency": 2959.96
},
{
    "note": "F#8",
    "frequency": 5919.91
},
{
    "note": "F0",
    "frequency": 21.83
},
{
    "note": "F1",
    "frequency": 43.65
},
{
    "note": "F2",
    "frequency": 87.31
},
{
    "note": "F3",
    "frequency": 174.61
},
{
    "note": "F4",
    "frequency": 349.23
},
{
    "note": "F5",
    "frequency": 698.46
},
{
    "note": "F6",
    "frequency": 1396.91
},
{
    "note": "F7",
    "frequency": 2793.83
},
{
    "note": "F8",
    "frequency": 5587.65
},
{
    "note": "G#0",
    "frequency": 25.96
},
{
    "note": "G#1",
    "frequency": 51.91
},
{
    "note": "G#2",
    "frequency": 103.83
},
{
    "note": "G#3",
    "frequency": 207.65
},
{
    "note": "G#4",
    "frequency": 415.3
},
{
    "note": "G#5",
    "frequency": 830.61
},
{
    "note": "G#6",
    "frequency": 1661.22
},
{
    "note": "G#7",
    "frequency": 3322.44
},
{
    "note": "G#8",
    "frequency": 6644.88
},
{
    "note": "G0",
    "frequency": 24.5
},
{
    "note": "G1",
    "frequency": 49
},
{
    "note": "G2",
    "frequency": 98
},
{
    "note": "G3",
    "frequency": 196
},
{
    "note": "G4",
    "frequency": 392
},
{
    "note": "G5",
    "frequency": 783.99
},
{
    "note": "G6",
    "frequency": 1567.98
},
{
    "note": "G7",
    "frequency": 3135.96
},
{
    "note": "G8",
    "frequency": 6271.93
}
]

const MIDI_NUM_NAMES = ["C_1", "C#_1", "D_1", "D#_1", "E_1", "F_1", "F#_1", "G_1", "G#_1", "A_1", "A#_1", "B_1",
    "C0", "C#0", "D0", "D#0", "E0", "F0", "F#0", "G0", "G#0", "A0", "A#0", "B0",
    "C1", "C#1", "D1", "D#1", "E1", "F1", "F#1", "G1", "G#1", "A1", "A#1", "B1",
    "C2", "C#2", "D2", "D#2", "E2", "F2", "F#2", "G2", "G#2", "A2", "A#2", "B2",
    "C3", "C#3", "D3", "D#3", "E3", "F3", "F#3", "G3", "G#3", "A3", "A#3", "B3",
    "C4", "C#4", "D4", "D#4", "E4", "F4", "F#4", "G4", "G#4", "A4", "A#4", "B4",
    "C5", "C#5", "D5", "D#5", "E5", "F5", "F#5", "G5", "G#5", "A5", "A#5", "B5",
    "C6", "C#6", "D6", "D#6", "E6", "F6", "F#6", "G6", "G#6", "A6", "A#6", "B6",
    "C7", "C#7", "D7", "D#7", "E7", "F7", "F#7", "G7", "G#7", "A7", "A#7", "B7",
    "C8", "C#8", "D8", "D#8", "E8", "F8", "F#8", "G8", "G#8", "A8", "A#8", "B8",
    "C9", "C#9", "D9", "D#9", "E9", "F9", "F#9", "G9"];


// Highcharts plugin to handle text symbols 
(function (H) {
    function symbolWrap(proceed, symbol, x, y, w, h, options) {
        if (symbol.indexOf('text:') === 0) {
            var text = symbol.split(':')[1],
                svgElem = this.text(text, x, y + h)
                    .css({
                        fontFamily: 'FontAwesome',
                        fontSize: h * 2
                    });

            if (svgElem.renderer.isVML) {
                svgElem.fillSetter = function (value, key, element) {
                    element.style.color = H.Color(value).get('rgb');
                };
            }
            return svgElem;
        }
        return proceed.apply(this, [].slice.call(arguments, 1));
    }
    H.wrap(H.SVGRenderer.prototype, 'symbol', symbolWrap);
    if (H.VMLRenderer) {
        H.wrap(H.VMLRenderer.prototype, 'symbol', symbolWrap);
    }

    // Load the font for SVG files also
    H.wrap(H.Chart.prototype, 'getSVG', function (proceed) {
        var svg = proceed.call(this);
        svg = '<?xml-stylesheet type="text/css" ' +
            'href="http://netdna.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" ?>' +
            svg;
        return svg;
    });
}(Highcharts));
*/